module.exports = __webpack_public_path__ + "img/54a71622-ec95-417f-bb9f-e2d274727ce6.webp.575a16fe.jpg";